import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Template from "../../templates";
import * as actions from "../../actions";
import { useLocation, useParams } from "react-router-dom";

export default () => {
  const moduleName = "products/comment/all";
  const params = useParams()
  const dispatch = useDispatch();
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const [id, setId] = useState();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    dispatch(actions.list(moduleName));
  }, []);

  useEffect(() => {
    if (appReducer.products_comment_all_list != undefined) {
      setRows(appReducer.products_comment_all_list.data)
      setTotalPages(appReducer.products_comment_all_list.count)
    }
  }, [appReducer])


  useEffect(() => {
    if (appReducer.products_comment_publish || appReducer.products_comment_unpublish) {
      dispatch(actions.list(moduleName));
    }
  }, [appReducer.products_comment_publish, appReducer.products_comment_unpublish])


  const handlePublish = id => dispatch(actions.publish(id, "products/comment"));
  const handleUnPublish = id => dispatch(actions.unpublish(id, "products/comment"));

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  const columns = [
    {
      name: 'نام',
      selector: row => row.comment,
    },
    {
      name: 'تصویر',
      selector: row => row.image_full ? <img src={row.image_small_full} /> : ""
    },
    {
      name: 'محصول',
      selector: row => row.product.name
    },
    {
      name: 'کاربر',
      selector: row => row.user.mobile
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <div className="flex py-4 gap-3">
        {row.state != "active" ? (
          <Template.Button
            onClick={() => handlePublish(row.id)}
            label="انتشار"
            background="bg-gradient-to-tr from-green-300 to-green-400  text-xs"
          />
        ) : (
          <Template.Button
            onClick={() => handleUnPublish(row.id)}
            label="عدم‌انتشار"
            background="bg-gradient-to-tr from-red-300 to-red-400  text-xs"
          />
        )}
      </div>,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

  // let row = [];
  // if (appReducer.products_comment_edit != undefined) {
  //   row = appReducer.products_comment_edit.data.map((col, c) => {
  //     let stateValue =  `فعال`
  //     if( col.state == "deactive"){
  //       stateValue =  `غیرفعال`;
  //     }
  //     return (
  //       <tr key={c}>
  //         <th scope="row">{col.id}</th>
  //         <td>{col.comment}</td>
  //         <td>{col.user && col.user.mobile}</td>
  //         <td>{stateValue}</td>
  //         <td>{col.created_at}</td>
  //         <td>

  //           {col.state != "active" ? (
  //             <Template.Button
  //               onClick={() => handlePublish(col.id)}
  //               label="انتشار"
  //               background="success btn-sm"
  //             />
  //           ) : (
  //             <Template.Button
  //               onClick={() => handleUnPublish(col.id)}
  //               label="عدم‌انتشار"
  //               background="danger btn-sm"
  //             />
  //           )}
  //         </td>
  //       </tr>
  //     );
  //   });
  // }
  // return (
  //   <Row>
  //     <Template.Card col="col-12" title={props.page}>
  //       <Template.Table
  //         btn={true}
  //         count={
  //           appReducer.products_comment_edit != undefined
  //             ? appReducer.products_comment_edit.count
  //             : 0
  //         }
  //         {...props}
  //         rows={row}
  //         fields={[
  //           {
  //             name: "id",
  //             value: "ردیف",
  //             sortable: true,
  //           },
  //           {
  //             name: "comment",
  //             value: "نظر",
  //           },
  //           {
  //               name: "mobile",
  //               value: "کاربر",
  //           },
  //           {
  //             name: "state",
  //             value: "وضعیت",
  //             sortable: true,
  //           },
  //           {
  //             name: "created_at",
  //             value: "تاریخ ایجاد",
  //             sortable: true,
  //           },
  //           {
  //             name: "operation",
  //             value: "عملیات",
  //           },
  //         ]}
  //       />
  //     </Template.Card>
  //   </Row>
  // );
};
